import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { assetUrl } from '@/utils/asset-url';
import { ReactComponent as IconDelete } from '@/assets/svgs/icon-delete.svg';
import { ReactComponent as IconRead } from '@/assets/svgs/icon-read.svg';
import { ReactComponent as IconPrevious } from '@/assets/svgs/previous-arrow.svg';
import AlertMessage from '@/components/AlertMessage';
// [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR.
// import Breadcrumbs from '@/components/Breadcrumbs';
import Breadcrumb from '@/dsComponents/Breadcrumb';
import Button from '@/components/Button';
import CardConfigure from "@/componentsDS/Modal/CardConfigure";
import Modal from "@/componentsDS/Modal/Modal";
import Pagination from '@/components/Pagination';
import Portal from '@/components/Portal';
import useModal from '@/hooks/use-modal';
import useNotifications from '@/hooks/use-notifications';
import usePage from '@/hooks/use-page';
import usePagination from '@/hooks/use-pagination';
import { useNavigate } from '@/lib/router-dom';
import API_NOTIFICATION from '@/services/api/notifications.js';
import rem from '@/utils/rem';
import classname from 'classnames';
import produce from 'immer';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Checkbox } from '@dextech-ai/dex-design-system';

const Page = () => {

	/*=================================================
		General
	/================================================*/

	const user = useSelector(state => state.auth.user)

	const [pageTitle, setPageTitle] = useState('Notifications')

	const { breadcrumbsItems } = usePage({ title: pageTitle, breadcrumbs: ['Explore Use Cases'] })

	const { goTo } = useNavigate()

	const itemsPerPage = 1

	const [open, setOpen] = useState(false)
	const [getData, setGetData] = useState(false)

	const { visible, show, hide } = useModal()
	const [alertMessage, setAlertMessage] = useState({
		status: null, message: null
	});

	const eventStatus = {
		ENROLMENTC_CREATE: "enrolment.create",
		ENROLMENTC_APPROVED: "enrolment.approved",
		SUBSCRIPTION_CREATE: "subscription.create",
		SUBSCRIPTION_APPROVE: "subscription.approved",
		SUBSCRIPTION_REJECT: "subscription.reject",
		SUBSCRIPTION_REVOKE: "subscription.revoked",
		SUBSCRIPTION_UNSUBSCRIBE: "subscription.unsubscribe"
	}

	/*=================================================
		API
	/================================================*/
	const [currentPage, setCurrentPage] = useState(1)
	const { items, fetch: getNotifications, setItems, meta } = useNotifications();

	const requestNotificationParameter =
	{
		currentPage: currentPage,
		pageSize: itemsPerPage
	}

	useEffect(() => {
		getNotifications()
	}, [getData])

	useEffect(() => {
		getNotifications(requestNotificationParameter)
	}, [currentPage])

	/*=================================================
		Pagination - Notifications
	/================================================*/

	const providerData = usePagination(items, itemsPerPage);
	const totalPage = Math.ceil(meta?.count / itemsPerPage)

	const onSelectCurrentCurrent = current => {
		setCurrentPage(current);
		// providerData.jump(current);
	}

	/*=================================================
		List
	/================================================*/

	const Lists = ({ data }) => {
		const list = data.map((item, index) => {
			const messageReadClass = classname({
				'notification-viewall-item': true,
				'notification-viewall-item--unread': item.status === 'UNREAD'
			})

			return (
				<div className={messageReadClass} key={index}>
					<Box display="flex" align="center">
						<div className="notification-item__checkbox">
							<Checkbox data-testid="notification-item-checkbox" checked={!!item.$selected} id={item.id} onCheckedChange={() => handleCheck(item.id)} />
						</div>
						<div className="notification-item__icon">
							<img src={item.body?.image} />
						</div>
					</Box>
					<div className="notification-viewall-item__column__message">
						<div className='notification-viewall-item__top notification-viewall-item__text--heading'>
						</div>
						<div className='notification-viewall-item__buttom notification-viewall-item__text'>
							{item.body?.dataElement?.length > 0 && (
								item.body.dataElement.map((dataElement, index)=> {
									return (
									<div key={index}>
										{index + 1}. {dataElement}
									</div>
								)
								})
							)}
						</div>
					</div>
					<div className="notification-viewall-item__column__time">
						<div className='notification-viewall-item__top notification-viewall-item__text--heading'>
							<nobr>{moment(item.date).format('DD MMM YYYY, h:mma')}</nobr>
						</div>
						<Box display="flex" justify="end">
							{ item.event === eventStatus.ENROLMENTC_APPROVED && user.type !== "system" && (
								<Button text="Request Data" full maxWidth="80" sizing='mini' submit={()=>requestData(item)} />
							)}

							{ item.event === eventStatus.SUBSCRIPTION_CREATE  && item.body?.status === "PENDING" && (
								<Button text="View Request" full maxWidth="100" sizing='mini' submit={() => viewRequest(item)} />
							)}


						</Box>
					</div>
				</div>
			)
		})

		return (
			list.length > 0 ?
				list
			: <div className="notification-viewall-item__empty notification-viewall-item__text--heading">There are no notifications</div>
		)
	}

	/*=================================================
		Checkbox
	/================================================*/
	const handleSelectAll = (checked) => {
		if (!providerData.currentData()) {
			return
		}

		const currentIds = providerData.currentData().map(notification => notification.id)

		const updatedItem = produce(items, draft => {
			draft.map(item => {
				return (currentIds.includes(item.id)) ? item.$selected = checked : null
			})
		})
		setItems(updatedItem)
	}

	function isAllChecked() {
		const isAllchecked = providerData.currentData().every(field => field.$selected)
		return isAllchecked;
	}

	const handleCheck = (id) => {
		const index = items.findIndex(item => item.id === id)
		const updatedItem = produce(items, (draft) => {
			draft[index].$selected = !draft[index].$selected
		})

		setItems(updatedItem)
	}

	function handleRemove() {
		show()
	}

	async function handleMarkRead() {
		const currectSelectedIds = providerData.currentData().filter(notification => notification.$selected === true).map(notification => notification.id)

		const payload = {
			notificationIds: currectSelectedIds,
		}

		const [error, result] = await API_NOTIFICATION.update('READ', payload)

		if (error) {
			return
		}

		if (result) {
			getNotifications();
			setGetData(true);
		}
	}

	/*=================================================
		Alert Message
	/================================================*/

	const messageText = (status) => {
		switch (status) {
			case 'delete':
				return 'Seleted notifications has been deleted.';
			default:
				return 'Something went wrong handling your Request';
		}
	}

	const triggerAlert = () => {
		async function updateAction() {
			const currectSelectedIds = providerData.currentData().filter(notification => notification.$selected === true).map(notification => notification.id)

			const payload = {
				notificationIds: currectSelectedIds,
			}

			const [error, result] = await API_NOTIFICATION.remove('DELETE', payload)

			if (error) {
				return
			}

			let resultStatus = '';
			hide();

			if (result) {
				resultStatus = "delete"
			} else {
				resultStatus = 'fail'
			}

			setAlertMessage({
				status: resultStatus,
				message: messageText(resultStatus)
			});
			setOpen(true)
			getNotifications()
			setGetData(true);

			setTimeout(() => {
				setOpen(false)
			}, 5000)
		}
		updateAction()
	}

	/*=================================================
		Navigate
	/================================================*/

	function onBack() {
		goTo(-1)
	}

	const requestData = (item) => {
		goTo(`/use-cases/${item.body?.useCaseId}/requests/new`)
	}

	const viewRequest = (item) => {
		goTo(`/use-cases/${item.body?.useCaseId}/view/${item.body?.subscriptionId}/provider`)
	}

	return (
		<>
			<Portal id="bread">
				{/* [DS-MIGRATION] legacy Breadcrumbs - replaced by DS-backed Breadcrumb. Remove in follow-up PR. */}
				{/* <Breadcrumbs items={breadcrumbsItems} /> */}
				<Breadcrumb items={breadcrumbsItems.map((label) => ({ label }))} />
			</Portal>

			<div className="title-header__back" onClick={onBack}>
				<div className=""><IconPrevious /></div>
				<div className="title-header__back__text link">Back</div>
			</div>

			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{pageTitle}</div>
				</div>
				<Box display="flex" justify="end"></Box>
			</div>

			<div id='alertLocation'>
				<AlertMessage open={open} status={alertMessage.status} text={alertMessage.message} location='alertLocation' />
			</div>

			<div className="notification-viewall">
				<div className="notification-header">
					<div className="notification-header__left">
						<Box display="flex">
							<div className="notification-header__col" >
								<Checkbox data-testid="select-all-checkbox" id="selectAll"
									checked={isAllChecked()}
									onCheckedChange={handleSelectAll}
									disabled={providerData.currentData().length===0}
								>
									Select All
								</Checkbox>
							</div>
							<div data-testid="mark-notification-read-btn" className="notification-header__col notification-header__col--icon" onClick={()=>handleMarkRead()}>
								<IconRead />
								<span>Mark as read</span>
							</div>
							<div data-testid="remove-notification-btn" className="notification-header__col notification-header__col--icon" onClick={()=>handleRemove()}>
								<IconDelete />
								<span>Remove</span>
							</div>
						</Box>

					</div>
				</div>
				<div className="notification-content">
					<Lists data={providerData.currentData()} />
				</div>
				<div className="notification-footer">
					<Box w="50%"></Box>
					<div className="notification-footer__right">
						<Pagination
							total={totalPage}
							maxShow={totalPage < 5 ? totalPage : 5}
							currentPage={currentPage}
							callback={onSelectCurrentCurrent}
						/>
					</div>
				</div>
			</div>


			<Modal visible={visible} variant='medium' close={hide}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Delete Notification
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div style={{ fontSize: rem(14), textAlign: 'center' }}>
								<strong>Are you sure you want to delete selected notifications?</strong>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<button data-testid="modal-confirm-btn" style={{ width: rem(80) }}
								onClick={() => {
									triggerAlert()
									hide()
								}}
							>Yes</button>
							<button data-testid="modal-cancel-btn" className="button--ghost" style={{ width: rem(80), marginLeft: rem(10) }}
								onClick={() => {
									hide()
								}}
							>No</button>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</>
	)
}
export default Page
